import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import {
  MODES,
  EDIT_HEADER_TITLES,
} from '../../common/advanced-editor/constants';
import Button from '../../../_common/button';

const ACTIVE_BTN_POSITION = 1;

class EditButtons extends React.PureComponent {
  static orderEditButtons(orderableButtons, editMode) {
    const orderableEditButtons = Object.assign([], orderableButtons);
    const activeEditBtn = orderableEditButtons.findIndex(({ props }) =>
      props.className.includes(editMode),
    );

    if (activeEditBtn !== -1) {
      [
        orderableEditButtons[ACTIVE_BTN_POSITION],
        orderableEditButtons[activeEditBtn],
      ] = [
        orderableEditButtons[activeEditBtn],
        orderableEditButtons[ACTIVE_BTN_POSITION],
      ];
    }

    return orderableEditButtons;
  }

  constructor(props) {
    super(props);
  }

  buttonClassNames = (MODE) => {
    const { editMode } = this.props;

    return classNames(`edit-btn ${MODE} text-nowrap`, {
      active: MODE === editMode,
    });
  };

  render() {
    const {
      handleEditMode,
      className,
      editMode,
      photoEditsCurrentValues,
      children,
      disabled,
    } = this.props;
    const { ROTATE, CROP, BRIGHTNESS, STRAIGHTEN, FILTERS } = MODES;

    const orderableButtons = [BRIGHTNESS, CROP, STRAIGHTEN].map((mode) => {
      return (
        <Button
          key={mode}
          type="button"
          className={this.buttonClassNames(mode)}
          aria-label={`${EDIT_HEADER_TITLES[mode]} value is ${photoEditsCurrentValues[mode]}`}
          onClick={() => handleEditMode(mode)}
          disabled={disabled}>
          {EDIT_HEADER_TITLES[mode]}
        </Button>
      );
    });

    return (
      <div
        className={classNames(
          'advanced-editor__edit-buttons align-items-center justify-content-around mx-auto',
          className,
        )}>
        <Button
          type="button"
          className={`edit-btn ${FILTERS}`}
          aria-label="Filters Edit"
          onClick={() => handleEditMode(FILTERS)}
          disabled={disabled}>
          Filters
        </Button>
        {EditButtons.orderEditButtons(orderableButtons, editMode)}
        <Button
          type="button"
          className={`edit-btn ${ROTATE}`}
          aria-label={`Rotate 90 degrees clockwise, current rotation is ${photoEditsCurrentValues[ROTATE]} degrees`}
          onClick={() => handleEditMode(ROTATE)}
          disabled={disabled}>
          Rotate
        </Button>
        {children}
      </div>
    );
  }
}

export default EditButtons;

EditButtons.propTypes = {
  handleEditMode: PropTypes.func.isRequired,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  editMode: PropTypes.oneOf(Object.values(MODES)),
};

EditButtons.defaultProps = {
  className: '',
  disabled: false,
};
